import React, { useState } from 'react'
import { Icon } from 'packages/eid-icons'
import { Box, makeStyles } from '@material-ui/core'
import TimeConstraintDialog from '../TimeConstraintDialog'
import { useAccessRequestPolicy } from 'hooks'

const useStyles = makeStyles({
    iconButton: ({ expanded }) => ({
        marginBottom: '0px',
        borderRadius: '5px',
        borderBottomLeftRadius: '0px',
        borderBottomRightRadius: '0px',
        display: 'flex',
        marginLeft: '4px',
        marginRight: '4px',
        margin: 'auto',
        paddingLeft: '0px',
        paddingRight: '0px',
        minWidth: '60px',
        backgroundColor: expanded ? '#efeff1' : 'inherit',
        '&:hover': {
            backgroundColor: '#efeff1 !important',
        },
    }),
})

const TimeConstraintButton = (props) => {
    const [expanded, handleExpand] = useState(false)
    const [anchorEl, setAnchorEl] = useState(null)
    const classes = useStyles({ expanded })

    const hasAccessToRequestPolicy = useAccessRequestPolicy(
        props.item.requestPolicyId,
    )
    
    return (
        <>
            {hasAccessToRequestPolicy ? (
                <Box>
                    <TimeConstraintDialog
                        anchorEl={anchorEl}
                        expanded={expanded}
                        data={props.item}
                        id={props.id}
                        requestPolicyData={hasAccessToRequestPolicy}
                        handleExpand={(e) => handleExpand(e)}
                    />
                    <Box
                        onClick={(e) => {
                            handleExpand(!expanded)
                            setAnchorEl(e.currentTarget)
                        }}
                    >
                        <iconButton className={classes.iconButton}>
                            <Icon
                                name={'TimeConstraint'}
                                color="#307fc1"
                                style={{
                                    marginBottom: '15px',
                                }}
                            />
                        </iconButton>
                    </Box>
                </Box>
            ) : (
                <></>
            )}
        </>
    )
}

export default TimeConstraintButton
